// Cargas do "casco" do layout (notificações, links do menu, medalhas da navbar, To-Do) que a API recusa com 423
// APPOINTMENT_REPORT_PENDING enquanto o PN tem report pendente — elas não estão na allowlist da trava no servidor.
// Disparadas na montagem do layout, cada uma viraria um 423 (toast de erro, rejeição sem tratamento, medalhas vazias)
// justamente na primeira tela que o PN travado vê: a central de pendências.
//
//   mixins: [reportLockAware],
//   mounted() { this.runWhenReportUnlocked(this.loadNotifications) },
//
// `runWhenReportUnlocked(fn)` espera a trava ser conhecida (`account/REFRESH_REPORT_LOCK`, que reaproveita a checagem
// do guard de rotas em andamento/recente; para quem não é PN resolve na hora, sem requisição) e roda `fn` se o acesso
// estiver liberado. Travado: roda UMA vez quando a trava sair (último report finalizado na central). O watcher some
// com o componente.
import * as accountTypes from '@/modules/account/store/types'

export default {
  computed: {
    reportLockActive() {
      return !!this.$store.getters[accountTypes.IS_REPORT_LOCKED]
    },
  },
  methods: {
    runWhenReportUnlocked(callback) {
      const run = () => {
        // eslint-disable-next-line no-underscore-dangle
        if (!this._isDestroyed) callback.call(this)
      }

      return this.$store.dispatch(accountTypes.REFRESH_REPORT_LOCK)
        .catch(() => null)
        .then(lock => {
          if (!(lock && lock.locked) && !this.reportLockActive) {
            run()
            return
          }
          const unwatch = this.$watch('reportLockActive', locked => {
            if (locked) return
            unwatch()
            run()
          })
        })
    },
  },
}
